import { ReactElement } from "react";
import * as React from "react";

import useLabelTypes from "../../../hooks/query/use-label-types";
import useText from "../../../hooks/use-text";
import { LocalizedStrings, SupportedLanguages } from "../../../utils/lang";
import MetaSelect from "../parts/meta-select";

type Props = {
  onChangeLabelTypes(labelTypesId?: string): void;
};

export default function LabelTypeSelector(props: Props): ReactElement {
  const { onChangeLabelTypes } = props;

  const { strings } = useText(local);
  const { data, loading } = useLabelTypes();

  if (loading || !data) {
    return <></>;
  }

  const { items: labelTypes } = data.labelTypes;

  return (
    <MetaSelect
      label={strings.label}
      name="value"
      getOptions={labelTypes}
      setOption={(v): void => onChangeLabelTypes(v["value"])}
      list={labelTypes.map((v): { text: string; value: string } => ({
        text: v.name,
        value: v.id,
      }))}
    />
  );
}

type LocalSchema = {
  label: string;
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    label: "Label Type",
  },
};
